import { Controller } from "stimulus"
import Trix from 'trix'
import axios from "axios"
import { debounce } from "lodash"

export default class extends Controller {

  connect(){
    this.currentAttachment = null
    this.alowAttach = false
    this.editor = this.element.closest('trix-editor').editor

    this.handleAddAttachment = this.handleAddAttachment.bind(this)
    document.addEventListener("trix-attachment-add", this.handleAddAttachment);

    this.handleClickTable = this.handleClickTable.bind(this)
    this.element.addEventListener("click",this.handleClickTable)

  }

  handleClickTable(event){
    let id = event.currentTarget.id;
    id = id.replace('table_', '')
    this.currentAttachment = this.searchAttachment(id)
  }

  handleAddAttachment(event){
    const { attachment } = event
    this.currentAttachment = attachment
  }


  searchAttachment(id){
    // find current Attachment  
    let element = this.context.controller.editor.composition.attachments.find(element => {
       if(element.attributes.values.sgid === id){
        return element
      }
    });

    return element
  }


  disconnect(){
    // Avoid infinitive loop
    if(!this.alowAttach) { return }

    this.updateTable()
  }

  updateTable(){
    axios({method: 'GET', url: this.urlValue})
    .then((response)=>{
      this.attachTable(response.data, false)
      this.currentAttachment = null
    })
  }

  addRow() {
    axios({method: 'PATCH', url: this.urlValue, params: {operation: 'addRow'}})
      .then((response)=>{
        this.attachTable(response.data)
      })
  }

  addColumn() {
    axios({method: 'PATCH', url: this.urlValue, params: {operation: 'addColumn'}})
      .then((response)=>{
        this.attachTable(response.data)
      })
  }

  removeRow() {
    axios({method: 'PATCH', url: this.urlValue, params: {operation: 'removeRow'}})
      .then((response)=>{
        this.attachTable(response.data)
      })
  }

  removeColumn() {
    axios({method: 'PATCH', url: this.urlValue, params: {operation: 'removeColumn'}})
      .then((response)=>{
        this.attachTable(response.data)
      })
  }

  updateCell = debounce((event) => {
    this.updateCellRequest(event.target.dataset.rowIndex, event.target.dataset.columnIndex, event.target.value)
  },500)

  updateCellRequest(rowIndex, columnIndex, value){
    axios({method: 'PATCH', url: this.urlValue, params: {
      operation: 'updateCell',
      row_index: rowIndex,
      column_index: columnIndex,
      value: value
    }}).then(()=> {
      this.alowAttach = true
    })
  }

  attachTable(tableAttachment, replace = true) {
    if(replace){
      let attachment = new Trix.Attachment({sgid: tableAttachment.sgid, content: tableAttachment.content})
      this.editor.insertAttachment(attachment)
      this.currentAttachment = attachment    
    }else{
      this.currentAttachment  && this.currentAttachment.setAttributes(tableAttachment)
    }
  }

  get urlValue() {
    return this.data.get("url-value")
  }
}